import script from "./ClientSurveyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientSurveyModal.vue?vue&type=script&setup=true&lang=js"

import "./ClientSurveyModal.vue?vue&type=style&index=0&id=cbaaf19a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbaaf19a"]])

export default __exports__